<template>
  <div>
    <yuanLingKongZhiQi v-bind="$attrs" />

    <!-- 水泵 -->
    <div v-if="hasFmList" class="part_title">水泵列表</div>
    <FMList v-if="hasFmList" :deviceType="type" :noClear="true" :pumpGroupsStatus="bumpStatusList"
      :manureStatusList="manureStatusList" :setting="seThres" :hasDeviceChange="hasDeviceChange"
      :refreshing="refreshing" />

    <!-- RTU 分组的 -->
    <div v-if="!system.length && portsList" class="part_title">
      <span>阀门列表</span>
      <van-button v-if="isSeconedRTU" type="primary" color="#598dee" class="orderSort"
        @click="() => handleChangeOrderSort(true)">{{ orderSort ? '按阀门号排序' : '按名称排序' }} <i
          class="iconfont icon-a-changyong_qiehuanfuben" :style="{ color: '#ffffff' }" />
      </van-button>
    </div>
    <van-tabs @click="handleTabClick" v-model="tabAcive" animated sticky v-if="system && system.length">
      <van-tab v-for="(item, index) in columns" :key="index" :name="index" :title="item" :badge="openFmCountArr[index]">
        <div class="famen_list">
          <van-loading v-if="loading" type="spinner" />
          <!-- 卡片 -->
          <div v-if="cardTriger === 'card'" class="famen_item" :class="port.status === 2 && 'errorPort'"
            v-for="(port, index) in portsList" :key="port.id">
            <div class="fm_row fm_row1">
              <div class="fm_name ellipsis">{{ port.portName }}</div>
              <div class="fm_xh">
                <span>
                  {{ port.irriIndex != null ? port.irriIndex + 1 : '' }}
                </span>
                <img :src="$requireImg('set.png')" @click="handleSetting(port)" />
              </div>
            </div>
            <div class="fm_row fm_row3">
              <div class="va_time fs26">
                <img :src="$requireImg('gtim.png')" class="img1" />
                &nbsp;
                <span>{{ port.timeStr }}</span>
              </div>
              <div>
                <van-switch class="switch" v-model="port.state" @change="handleSwitch($event, port, index)"
                  :active-value="true" :inactive-value="false" active-color="#1989fa" inactive-color="#ffffff"
                  size="24" />
              </div>
            </div>
          </div>
          <!-- 一行 -->
          <div v-if="cardTriger === 'list'" class="famen_list_item" :class="port.status === 2 && 'errorPort'"
            v-for="(port, index) in portsList" :key="port.id">
            <van-row>
              <van-col span="9" class="ellipsis"> {{ port.portName }}</van-col>
              <van-col span="4">
                <span class="mpa">
                  {{ port.irriIndex != null ? port.irriIndex + 1 : '' }}
                </span>
              </van-col>
              <van-col span="7" class="time-count">
                <span>
                  <img :src="$requireImg('gtim.png')" class="img1" />
                </span>
                &nbsp;
                <span>{{ port.timeStr }}</span>
              </van-col>
              <van-col span="4">
                <van-switch class="switch" v-model="port.state" @change="handleSwitch($event, port, index)"
                  :active-value="true" :inactive-value="false" active-color="#1989fa" inactive-color="#ffffff"
                  size="24" />
              </van-col>
            </van-row>
            <span class="setting">
              <img :src="$requireImg('set.png')" @click="handleSetting(port)" />
            </span>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 旧的 没有分类的阀门展示 -->
    <!-- 旧的 没有分类的阀门展示 -->
    <!-- 旧的 没有分类的阀门展示 -->
    <div class="famen_list" v-else>
      <van-loading v-if="loading" type="spinner" />
      <!-- 卡片 -->
      <div v-if="cardTriger === 'card'" class="famen_item" :class="port.status === 2 && 'errorPort'"
        v-for="(port, index) in portsList" :key="port.id">
        <div class="fm_row fm_row1">
          <div class="fm_name ellipsis">{{ port.portName }}</div>
          <div class="fm_xh">
            <span>
              {{ port.irriIndex != null ? port.irriIndex + 1 : '' }}
            </span>
            <img :src="$requireImg('set.png')" @click="handleSetting(port)" />
          </div>
        </div>
        <div class="fm_row fm_row3">
          <div class="va_time fs26">
            <img :src="$requireImg('gtim.png')" class="img1" />
            &nbsp;
            <span>{{ port.timeStr }}</span>
          </div>
          <div>
            <van-switch class="switch" v-model="port.state" @change="handleSwitch($event, port, index)"
              :active-value="true" :inactive-value="false" active-color="#1989fa" inactive-color="#ffffff" size="24" />
          </div>
        </div>
      </div>
      <!-- 一行 -->
      <div v-if="cardTriger === 'list'" class="famen_list_item" :class="port.status === 2 && 'errorPort'"
        v-for="(port, index) in portsList" :key="port.id">
        <van-row>
          <van-col span="9" class="ellipsis">{{ port.portName }}</van-col>
          <van-col span="4">
            <span class="mpa">
              {{ port.irriIndex != null ? port.irriIndex + 1 : '' }}
            </span>
          </van-col>
          <van-col span="7" class="time-count">
            <span>
              <img :src="$requireImg('gtim.png')" class="img1" />
            </span>
            &nbsp;
            <span>{{ port.timeStr }}</span>
          </van-col>
          <van-col span="4">
            <van-switch class="switch" v-model="port.state" @change="handleSwitch($event, port, index)"
              :active-value="true" :inactive-value="false" active-color="#1989fa" inactive-color="#ffffff" size="24" />
          </van-col>
        </van-row>
        <span class="setting">
          <img :src="$requireImg('set.png')" @click="handleSetting(port)" />
        </span>
      </div>
    </div>
    <pageToast ref="pageToast" />
  </div>
</template>

<script>
import Panel from './../../Panel'
import FMList from './../../fmList'
import { mapState } from 'vuex'
import yuanLingKongZhiQi from "./index.vue"


const time_sw_change = 30
const count = 20
let switchStatus = false

export default {
  components: {
    Panel,
    FMList,
    yuanLingKongZhiQi
  },
  props: {
    type: {
      type: String | Number,
      default: null,
    },
    setting: {
      type: Function,
      default: (argument) => { },
    },
    hasDeviceChange: {
      type: Boolean,
      default: false,
    },
    cardTriger: {
      type: String,
      default: 'card',
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pressure () {
      return function (value) {
        if (value === '#') {
          return '#'
        } else {
          return Number(value).toFixed(3)
        }
      }
    },
    shifeiRunTimeStatus () {
      return function (num) {
        console.log("num:", num);
        // 01：正在灌溉 02：正在预充 03：正在施肥 04 正在冲洗
        if (num == 1) return '正在灌溉'
        else if (num == 2) return '正在预充'
        else if (num == 3) return '正在施肥'
        else if (num == 4) return '正在冲洗'
        else if (num == 5) return '已灌溉'
        else return '未灌溉'
      }
    },
    ...mapState(['subscribeTag', 'sseData']),
  },

  data () {
    let openRTUActionIndex = sessionStorage.getItem('openRTUActionIndex')
    if (typeof openRTUActionIndex !== 'number') {
      openRTUActionIndex = null
    }

    return {
      no: localStorage.getItem('no'),
      portsList: [], // 名称排序阀门列表
      oldPortsList: [],
      newPortsList: [],
      orderSortList: [], // 阀门徐好排序列表
      system: [],
      columns: [],
      systemName: '',
      tabAcive: 0,
      loading: false,
      openFmCountArr: [], // 开启阀门的数量 number[]
      hasFmList: false,
      openRTUActionIndex, // 操作了那个开关的下标
      collapse: [],
      valveRtuRelationList: [], // rtu和轮灌组阀门的关联关系
      pumpGroupsStatus: [],
      valveGroupsStaus: [],
      showTime: [
        {
          key: "totalTime",
          label: "共计用时",
          value: "",
        },
        {
          key: "startTime",
          label: "开始时间",
          value: "",
        },
        {
          key: "remainderTime",
          label: "剩余时间",
          value: "",
        },
        {
          key: "endTime",
          label: "完成时间",
          value: "",
        },
      ],
      stime: "",
      etime: "",
      valveGroups: [],
      currentGroup: null, // 当前执行到第几组
      status: false,
      runTime: 0, // 已行时间
      totalGroup: 0, // 共多少组
      process: 0, // 进度
      processText: "",
      isSeconedRTU: this.type == 13 || this.type == 14 || this.type === 17 || this.type === 18 || this.type === 23,
      orderSort: true,
      sensorList: [], // 检测数据
      proId: null,
      groupStatus: {},
      requireManure: false,
      loadMin: 0,
      totalMin: 0,
      bumpStatusList: [],
      manureStatusList: [],
      valStatusList: [],
    }
  },

  destroyed () {
    // 卸载清除掉定时器
    this.portsList.map((item) => {
      if (item.timer) {
        clearInterval(item.timer)
      }

      if (item.ports && item.ports.length) {
        item.ports.map((_item) => {
          if (_item.timer) {
            clearInterval(_item.timer)
          }
        })
      }
    })
  },

  watch: {
    // 订阅消息需要更新值
    async subscribeTag (v) {
      // 有改变 则修改收到的值
      if (typeof this.openRTUActionIndex === 'number') {
        if (this.sseData && this.sseData.code == 1) {
          await this.refreshPorts(this.openRTUActionIndex)
        } else {
          this.$message.error(this.sseData.message)
        }
      }
    },

    async hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem('no')
        this.no = no
        this.init()
      }
    },

    refreshing (bl) {
      // 有下拉刷新
      if (bl) {
        this.onRefresh()
      }
    },

    // 监听阀门的变化
    portsList () {
      this.$nextTick(() => {
        this.renderRTUListToCollapse()
      })
    },
  },

  async created () {
    const no = localStorage.getItem('no')
    this.no = no
    this.init()


  },



  methods: {
    async init () {
      await this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      })

      console.time()
      // 获取阀门和轮灌组之间的关系接口
      this.isSeconedRTU && await this.getValveRtuRelation()
      // 获取水泵阀门数据 看是否存在水泵阀门 有则展示水泵阀门列表


      await this.getGatewayDefaultFmList()
      // 阀门分系统
      await this.getFmDetail()



      // 查询程序状态 找到开启中的程序 再去获取程序的执行状态
      // 没有找到则使用第一个程序的信息

      console.error("进来了");

      if (this.isSeconedRTU) {
        await this.getFirstScreenData()
      }
      // 这一步 没有请求，提取公共方法，绑定RTU和轮灌组阀门之间的关系
      this.valveRtuRelation()
      this.handleChangeOrderSort()
      console.timeEnd();
    },

    // 获取首页数据
    async getFirstScreenData () {
      await this.$api.lgV5_getFirstScreenData({ gatewayNo: this.no }).then(res => {
        if (res.errcode === 0) {
          const {
            programStatus: {
              status, // 开启状态
              runTime,// 已运行时长
              totalGroup, // 共多少组
              groupIndex, // 当前第几组
              proId, // 程序序号
            }, // 程序状态
            groupStatus, // 组的状态
            sensorList, // 传感器检测值
            requireManure,
            totalTime,
            remainderTime,
            bumpStatusList, // 水泵
            manureList, // 施肥机
            manureStatusList, // 施肥机
            valStatusList, // 阀门
            level = [0, 0], // 水位传感器
          } = res.data
          this.bumpStatusList = [...bumpStatusList]
          this.manureStatusList = [...(manureStatusList || manureList || [])]
          this.valStatusList = [...valStatusList]
          this.proId = proId + 1
          this.requireManure = requireManure
          this.groupStatus = { ...groupStatus }

          // 时间展示
          this.showTime.map(o => {
            if (o.key === 'startTime' || o.key === "endTime") {
              let data = res.data[o.key] ?
                res.data[o.key].indexOf(" ") > -1 ?
                  res.data[o.key].split(" ").reverse().join(" ") :
                  "" : "";
              o.value = data ? data : null
            } else {
              o.value = this.getTime(res.data[o.key])
            }
          })

          // 正在执行的组 共有多少组
          this.currentGroup = groupIndex !== null ? groupIndex + 1 : 0
          this.status = status // 0关闭 1开启 2暂停 3停止
          this.runTime = (runTime / 60).toFixed(2)
          this.totalGroup = totalGroup
          const real = []
          const pressure = []
          sensorList.map((o, i) => {
            real.push({ label: `流量${i + 1}`, value: o.realTimeFlow ? (o.realTimeFlow / 100).toFixed(2) : 0, unit: 'm³/h(实时)  ', })
            real.push({ label: null, value: o.totalFlow ? (o.totalFlow / 100).toFixed(2) : 0, unit: 'm³(总)' })
            pressure.push({ label: `压力${i + 1}`, value: o.pressure ? (o.pressure / 10).toFixed(2) : 0, unit: 'MPa' })
          })

          level?.map((o, i) => {
            pressure.push({ label: `水位${i + 1}`, value: o ? (o / 100).toFixed(2) : 0, unit: "m" })
          })

          this.sensorList = [...real, ...pressure]


          if (totalTime) {
            // 开始的时间 = 总的时间 -  剩余时间
            this.stime = this.getTime(totalTime - remainderTime)
            this.etime = this.getTime(totalTime)
          }

          const loadTime = totalTime - (remainderTime)

          this.process = ((groupStatus.havRunTime / (groupStatus.setTime)).toFixed(1)) * 100
          const t = groupStatus.havRunTime ? groupStatus.havRunTime / 60 : 0;
          this.loadMin = String(t).indexOf(".") > -1 ? t.toFixed(2) : t;

          this.totalMin = Math.ceil(groupStatus.setTime / 60)

          console.log("this.process: ", this.process, loadTime, totalTime);
        } else {
          setTimeout(() => {
            this.$toast({
              message: `获取首屏数据异常：${res.errmsg}`,
              duration: 1500,
            })
          }, 10);
        }
      })
    },

    // RTU阀门对应轮灌组阀门的关系
    valveRtuRelation () {
      const portsList = [...this.portsList]
      console.log("拍好顺序的阀门:", portsList);
      portsList.map(item => {
        const target = this.valveRtuRelationList.find(o => o.valveId === item.id)
        if (target) {
          item.irriIndex = target.irriIndex
          //  irriIndex 就是阀门的数组下标
          if (this.valStatusList && this.valStatusList.length) {
            const valave = this.valStatusList[target.irriIndex]

            // 如果轮灌阀门序号存在，则以轮灌组的阀门状态为准
            if (valave) {
              item.state = valave?.status == 1
              if (item.state) {
                item.timeStr = valave?.time ? this.calculationTime(valave.time) : "00:00:00"
              }
            }
          }
        }
      })

      // 这里做RTU阀门和轮灌组的关联  拿到开关状态和开启时长
      this.oldPortsList = [...portsList]
      this.portsList = [...portsList]
    },


    getTime (second = 0, needHour) {
      second = Number(second);
      let h = 0,
        m = 0,
        s = 0;

      const u_h = 60 * 60;
      const u_m = 60;

      h = Math.floor(second / u_h);
      m = Math.floor((second - h * u_h) / u_m);
      s = second - h * u_h - m * u_m;

      const M = String(m).padStart(2, "0");
      const S = String(s).padStart(2, "0");
      if (h || needHour) {
        const H = String(h).padStart(2, "0");
        return `${H}:${M}:${S}`;
      }

      return `${M}:${S}`;
    },

    translateMinus (time) {
      if (time) {
        const t = (Number(time) / 60)
        return String(t).indexOf(".") > -1 ? t.toFixed(2) : t
      }
      return time
    },

    handleDoor () {
      sessionStorage.setItem("deviceType", this.type);
      this.$router.push("/lunguan");
    },

    // rtu和轮灌组阀门的关联关系
    async getValveRtuRelation () {
      await this.$api.lgV2_getValve_rtu_relation(this.no).then(res => {
        try {
          if (res.errcode === 0) {
            this.valveRtuRelationList = res.data
            sessionStorage.setItem("valveRtuRelationList", JSON.stringify(this.valveRtuRelationList))
          } else {
            this.valveRtuRelationList = []
          }
        } catch (e) {
          console.error("e:", e);
        }
      })
    },


    // 查询网关阀门 有则将阀门添加进portLists 头部
    async getGatewayDefaultFmList () {
      return await this.$api
        .getValaveList({
          gatewayNo: this.no,
        })
        .then((res) => {
          if (res.errcode === 0 && res.list && res.list.length) {
            return (this.hasFmList = true)
          }
          return (this.hasFmList = false)
        })
    },

    async getFmDetail () {
      const no = localStorage.getItem('no')
      this.no = no
      let rtulist = []
      // 阀门分类的列表
      await this.$api
        .getValaveClassifyList({ gatewayNo: this.no, }).then((res) => {
          if (res && res.data && res.data.length) {
            this.system = [...res.data.reverse()]
            this.columns = this.system.map((item) => item.name)
            this.systemName = this.columns[0]
          } else {
            this.system = []
            this.columns = []
            this.$refs.pageToast.type = 1
            this.portsList = []
          }



          console.log("system:", this.system);
        })

      // 如果有系统则用分类 没有则保留原有方式
      if (this.system && this.system.length) {
        // 然后拿第一个系统去请求阀门明细
        await this.system.map(async (item, index) => {
          const list = await this.getFmListDetail(item.id)
          let count = 0
          await list.map((_item) => {
            if (_item.state) count++
          })
          this.openFmCountArr[index] = count
        })
        this.handleTabClick(0, this.columns[0])
        // 开启计时器
        this.setStrTime(true)
      } else {
        rtulist = await this.getRTUList(no)
        await this.getRTUInfo(rtulist)
      }
    },

    // 获取阀门列表明细
    async getFmListDetail (id) {
      return await this.$api
        .getValaveClassifyDetail({
          sortId: id,
        })
        .then((res) => {
          if (res.errcode === 0 && res.data && res.data.length) {
            res.data.map((item) => {
              item.systemTimestamp = res.systemTimestamp
              item.rtuNo = item.no
            })

            return [...res.data]
          } else {
            return []
          }
        })
    },

    // 计算打开的阀门数
    openFmCountFun (list) {
      let openFmCount = 0
      list &&
        list.length &&
        list.map((item) => {
          if (item.state) {
            openFmCount++
          }
        })

      return openFmCount
    },

    // tab 切换
    handleTabClick (index, value) {
      this.tabAcive = index
      this.loading = true
      this.portsList = []
      setTimeout(async () => {
        let list = [...(await this.getFmListDetail(this.system[index].id))]
        await this.getRTUInfo(list, 2)
        this.openFmCountArr[index] = this.openFmCountFun(this.portsList)
        this.setStrTime(true)
        this.loading = false
      }, 100)
    },

    // 获取RTU列表
    async getRTUList (no) {
      if (this.$isblank(no)) {
        this.$toast(this.$t('export.tis_dev'))
        return false
      }
      // 这个翻页好像是没用的
      return this.$api.getRtuList({ gatewayNo: no, page: 1, pageSize: 5, })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.data)) {
              return [...res.data]
            } else {
              this.$refs.pageToast.type = 1
              return []
            }
          } else {
            this.$toast(res.errmsg)
            return []
          }
        })
    },

    async getRTUInfo (rtuList, method) {
      if (rtuList && rtuList.length) {
        this.$refs.pageToast.type = 0
        let portsList = []
        if (method === 2) {
          await rtuList.map(async (item, index) => {
            item = {
              ...item,
              rtuNo: item.no,
              systemTimestamp: item.systemTimestamp,
              nameFirst: item.portName[0],
              nameSecod: item.portName.match(/\d{1,}/g)
                ? item.portName.match(/\d{1,}/g)[0]
                : '',
            }
            portsList.push(item)
          })
        } else {
          await rtuList.map(async (item, index) => {
            if (item.valves && item.valves.length) {
              item.valves.map((_item) => {
                _item = {
                  ..._item,
                  rtuNo: item.no,
                  systemTimestamp: item.systemTimestamp,
                  nameFirst: _item.portName[0],
                  nameSecod: _item.portName.match(/\d{1,}/g)
                    ? _item.portName.match(/\d{1,}/g)[0]
                    : '',
                }
                portsList.push(_item)
              })
            }
          })
        }

        let list = [...this.sortRTU(portsList)]

        if (list && list.length) {
          this.portsList = [...list]

          this.$refs.pageToast.type = 0
        } else {
          this.portsList = []
          this.$refs.pageToast.type = 1
        }
        await this.setStrTime(true)


      } else {
        this.$refs.pageToast && (this.$refs.pageToast.type = 1)
      }
    },

    sortRTU (rtuList) {
      const data = [...rtuList]
      let reg = /\d{1,}/g
      let names = []
      let group = new Set()
      // 先分组
      let groupTrunk = []

      if (data && data.length) {
        data.map((item) => {
          group.add(item.nameFirst)
        })
        group = Array.from(group).sort()
        group.map((groupId) => {
          let arr = []
          data.map((item) => {
            if (groupId === item.nameFirst) {
              arr.push(item)
            }
          })
          groupTrunk = groupTrunk.concat(this.sortGroup(arr))
        })
      }

      groupTrunk.map((item) => {
        names.push(item.portName)
      })

      return groupTrunk
    },

    sortGroup (data) {
      // 第二排序条件
      return data.sort((a, b) => {
        let _a = Number(a.nameSecod)
        let _b = Number(b.nameSecod)
        return _a - _b
      })
    },

    /**
     * @description 将整个阀门列表进行遍历进行判断是否开启定时器
     * @param {boolean} openTimer true 需要重新去走定时器 false 不用
     */
    setStrTime (openTimer) {
      this.portsList.map((item) => {
        let timeStep = null
        let nowDate = item.systemTimestamp
        if (!item.timeStr) {
          item.timeStr = '00:00:00'
        }
        // 操作时间存在且开关是打开状态
        if (item.time && item.state) {
          // 将 - 替换成 / 兼容 iphone
          item.time = item.time.replace(/-/g, '/')
          timeStep = nowDate - new Date(item.time).getTime()
          timeStep = Math.ceil(timeStep / 1000)
          // 计算出 时 分 秒
          item.timeStr = this.calculationTime(timeStep)
          this.$forceUpdate()
          // if (openTimer) {
          //   item.timer && clearInterval(item.timer)
          //   item.timer = setInterval(() => {
          //     timeStep++
          //     item.timeStr = this.calculationTime(timeStep)
          //     this.$forceUpdate()
          //   }, 1000)
          // }
        }
      })
    },

    /**
     * @descript 查新RTU的具体信息
     * @param {number} rtuNo rtu编号
     */
    async getRTUPortInfo (rtuNo) {
      return await this.$api
        .getRtuPort({ rtuNo })
        .then((res) => {
          if (res.errcode === 0 && res.data && res.data.length) {
            const data = [...res.data]
            data.map((item) => {
              item.systemTimestamp = res.systemTimestamp
            })
            return data
          } else {
            return []
          }
        })
        .catch((err) => {
          console.log(err)
          return []
        })
    },

    // 设置
    handleSetting (item) {
      // 查询设备的配置信息
      sessionStorage.setItem('liveSettingData', JSON.stringify(item))
      this.$router.push({
        path: '/liveSetting',
        query: {
          type: 'rtu',
        },
      })
    },

    /**
     * @description 开关
     * @param {boolean} value 开关状态 true 开 false 关
     * @param {portItem} portInfo 操作的端口阀门信息
     * @param {number} index  所属rtu列表的下标
     */
    async handleSwitch (value, portInfo, index) {

      console.log("this.portsList[index]:", this.portsList[index]);

      if (switchStatus) {
        this.$toast({
          message: '发送指令时间间隔为2秒，请稍后重试!',
          duration: 1500,
        })
        this.portsList[index].state = !value

        return false
      }

      switchStatus = true
      setTimeout(() => {
        switchStatus = false
      }, 2000)

      let text = 9
      const toast = this.$toast.loading({
        message: `倒计时 ${text} 秒`,
        duration: 0,
        forbidClick: true,
      })

      let timer = setInterval(() => {
        text--
        if (text >= 0) {
          toast.message = `倒计时 ${text} 秒`
        } else {
          clearInterval(timer)
          // 手动清除 Toast
          this.$toast.clear()
        }
      }, 1000)

      this.portsList[index].state = !value

      await this.$api
        .rtuSwitch({
          no: portInfo.rtuNo,
          switchStt: value ? 1 : 0,
          eqValveId: portInfo.id,
        })
        .then(async (res) => {
          clearInterval(timer)

          this.openRTUActionIndex = index
          sessionStorage.setItem('openRTUActionIndex', index)

          if (res.errcode === 0) {
            this.$toast.clear()
            this.$toast.success(`${value ? `「${this.portsList[index].portName}」开启` : `「${this.portsList[index].portName}」关闭`}成功`)
            this.portsList[index].state = value
            // 开启阀门  要开始计时

            if (value) {
              // 重新获取该RTU信息 并插入到原来位置 目的是为了拿 systemTimestamp
              const res = await this.getRTUPortInfo(portInfo.rtuNo)
              if (res && res.length) {
                let t = null
                res.map((item) => {
                  if (item.id === portInfo.id) {
                    t = { ...item, rtuNo: portInfo.rtuNo }
                  }
                })
                if (t) {
                  this.portsList[index].time = t.time
                  this.portsList[index].systemTimestamp = t.systemTimestamp
                  let timeStep = null
                  timeStep =
                    t.systemTimestamp -
                    new Date(`${t.time}`.replace(/-/g, '/')).getTime()
                  timeStep = Math.ceil(timeStep / 1000)
                  this.portsList[index].state = t.state

                  this.portsList[index].timeStr = this.calculationTime(timeStep)

                  clearInterval(this.portsList[index].timer)

                  // this.portsList[index].timer = setInterval(() => {
                  //   ++timeStep
                  //   this._data.portsList[index].timeStr = this.calculationTime(
                  //     timeStep,
                  //   )
                  //   this.$forceUpdate()
                  // }, 1000)
                }

                // 开关操作 轮训该阀门所属的RTU 不要定时了 改为订阅消息
                // this.openInterval(index);
              }
            } else {
              // 关闭阀门 要将该阀门计时器关闭 并将timeStr置为00:00:00
              this.portsList[index].timeStr = '00:00:00'
              clearInterval(this.portsList[index].timer)
              let closeRefreshCount = 0
              // 关闭阀门 一分钟后查一次阀门压力

              let _timer = setInterval(async () => {
                console.error('10秒查询')

                if (closeRefreshCount > 3) {
                  clearInterval(_timer)
                } else {
                  const list = await this.getRTUPortInfo(
                    this.portsList[index].rtuNo,
                  )
                  if (list && list.length) {
                    list.find((o) => o.id)
                    const t = list.find(
                      (o) => o.id === this.portsList[index].id,
                    )
                    this.portsList[index] = Object.assign(
                      this.portsList[index],
                      t,
                    )
                  }
                  closeRefreshCount++
                }
              }, 10 * 1000)
            }

            // this.portsList = [...portsList];
            // value 为true 需要打开定时器，false 不用管
            // this.setStrTime(false);
          } else {
            await this.$toast.clear()
            clearInterval(timer)
            await this.$toast.fail(
              res.errmsg || `${value ? '开启阀门' : '关闭阀门'}失败`,
            )
          }

          this.openFmCountArr[this.tabAcive] = this.openFmCountFun(
            this.portsList,
          )
        })
        .catch((err) => { })
    },

    // 打开定时器
    openInterval (index) {
      const t = this.portsList[index]
      // 如果操作的开关属于同一个RTU ，该RTU 还存在轮训计数，则不做重新计数开启轮训
      if (t.timerCount) {
        return false
      } else {
        t.timerCount = 0
      }

      // 开始轮训
      t.timer2 = setInterval(async () => {
        if (t.timerCount > count) {
          clearInterval(t.timer2)
        } else {
          await this.refreshPorts(index)
          ++t.timerCount
        }
      }, time_sw_change * 1000)
    },

    // 更新RTU
    async refreshPorts (index) {
      // 刷对应的RTU数据
      let portItem = this.portsList[index]
      const portInfo = await this.getRTUPortInfo(portItem.rtuNo)
      if (portInfo && portInfo.length) {
        const t = portInfo.find((o) => o.id === portItem.id)
        if (t) portItem = Object.assign(portItem, t)
      }
    },

    // 下拉刷新
    async onRefresh () {
      // 关系
      this.isSeconedRTU && await this.getValveRtuRelation()
      // 停止所有定时器
      this.portsList.map((item) => {
        if (typeof item.timer === 'number') {
          clearInterval(item.timer)

          item.timer = null
        }
        if (typeof item.timer2 === 'number') {
          clearInterval(item.timer2)
          item.timer2 = null
        }

        delete item.timerCount
        delete item.timer
        delete item.timer2
      })

      if (this.system && this.system.length) {
        this.portsList = []
        const list = [
          ...(await this.getFmListDetail(this.system[this.tabAcive].id)),
        ]
        await this.getRTUInfo(list, 2)
        this.setStrTime(true)
      } else {
        const list = await this.getRTUList(this.no)
        await this.getRTUInfo(list)
      }

      if (this.isSeconedRTU) {
        this.getFirstScreenData()
      }

      await this.valveRtuRelation()
      await this.handleChangeOrderSort()


      this.$toast.clear()
    },

    /**
     * @desc 计算时间 输出 00:00:00
     * @param {number} timeStemp  单位:秒
     * @return {string}  00:00:00
     */
    calculationTime (timeStemp) {
      return this.$calculationTime(timeStemp)
    },

    /**
     * @description 报警阈值  /  阀门定时设置  / RTU定时设置
     * @param {*} item 数据
     * @param {*} type 类型  0 传感情的报警阀值  1 阀门定时器  2 RTU定时器
     */
    seThres (item, type) {
      sessionStorage.setItem(
        'liveSettingData',
        JSON.stringify({ ...item, no: this.no }),
      )
      this.$router.push({
        path: '/liveSetting',
        query: {
          type: 'cgq',
        },
      })
    },

    // 不修改前面写好的RTU列表数据结构
    // 重新将RTU列表包装成折叠面板的模式
    // 不想优化了 RTU很头痛
    // 不想优化了 RTU很头痛
    // 不想优化了 RTU很头痛

    renderRTUListToCollapse () {
      if (this.portsList && this.portsList.length) {
        const list = JSON.parse(JSON.stringify(this.portsList))
        let group = new Set()
        list.map((item) => group.add(item.rtuNo))
        group = Array.from(group)
        group.sort((a, b) => a.rtuNo - b.rtuNo)
        const newList = []
        group.map((item) => newList.push({ rtuNo: item, port: [] }))
        newList.map((item) => {
          list.map((rtu) => {
            if (rtu.rtuNo === item.rtuNo) {
              item.port.push(rtu)
            }
          })
        })
        this.newPortsList = [...newList]
      }
    },

    handleToLog (data) {
      this.$router.push({
        path: '/gatewayLog',
        query: {
          rtuNo: data.rtuNo,
        },
      })
    },

    handleChangeOrderSort (needTrriger = false) {
      // 数据的默认排序是按名称，展示需要默认按阀门号排序
      // true 按阀门号排序  false 是名称排序
      needTrriger && (this.orderSort = !this.orderSort)

      // 将阀门号位为空的先踢掉


      if (this.orderSort) {
        // 按阀门号排序
        const portsList = JSON.parse(JSON.stringify([... this.portsList]))
        let index = 1
        portsList.map(o => {
          if (!o.hasOwnProperty("irriIndex")) {
            o._irriIndex = 999 + index
            ++index
          } else {
            o._irriIndex = o.irriIndex
          }
        })
        portsList.sort((a, b) => Number(a._irriIndex) - Number(b._irriIndex))
        console.log("portsList:", portsList);

        this.orderSortList = [...portsList]
        this.portsList = [... this.orderSortList]
      } else {
        // 按名称排序
        this.portsList = [...this.oldPortsList]
      }


      this.portsList = this.portsList.filter(o => (o.irriIndex != null))
    }
  },
}
</script>

<style lang="scss" scoped>
.fm_name {
  font-size: 14px;
}

.port,
.task {
  font-size: 12px;
}

.famen_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;

  .rtu_item {
    width: 100%;

    .rtu_info {
      display: flex;
      height: 40px;
      line-height: 40px;
      justify-content: space-between;
    }
  }

  .famen {
    display: flex;
    flex-wrap: wrap;
  }

  .famen_item {
    width: 49%;
    min-height: 1.4rem;
    box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
    border-radius: 0.1rem;
    background: #ffffff;
    margin-bottom: 0.2rem;
    padding: 0.1rem 0.15rem;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0 !important;
    }

    .fm_row {
      display: flex;
      height: 34px;
      line-height: 34px;
    }

    .fm_row1 {
      display: flex;
      justify-content: space-between;

      .fm_xh {
        span {
          font-size: 12px;
          margin-right: 6px;
          vertical-align: top;
        }

        .icon-wifi,
        .icon-dc {
          margin-right: 8px;
        }

        .icon-wifi {
          color: green;
        }

        .icon-dc {
          color: red;
          font-size: 20px;
          vertical-align: bottom;
        }

        img {
          width: 14px;
          height: 14px;
          vertical-align: baseline;
        }
      }
    }

    .fm_row2 {
      display: flex;
      justify-content: space-between;
    }

    .fm_row3 {
      display: flex;
      justify-content: space-between;
      width: 100%;

      img {
        width: 16px;
        height: 16px;
        vertical-align: sub;
      }
    }
  }

  .famen_list_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    background: #ffffff;
    margin-bottom: 0.1rem;
    padding: 0.1rem;
    box-sizing: border-box;

    img {
      width: 20px;

      &:last-child {
        width: 16px;
      }
    }

    .setting {
      float: right;
    }

    /deep/ .van-row {
      width: 100%;
    }
  }

  .switch {
    font-size: 20px !important;
    vertical-align: middle;
  }

  .time-count {
    text-align: right;

    img {
      width: 14px !important;
      margin-bottom: 3px;
    }
  }

  .mpa {
    font-size: 12px;
  }
}

.errorPort {
  background: #f5dede !important;
}

/deep/ .van-tabs {
  height: 100%;
}

/deep/ .van-tabs__line {
  bottom: 23px !important;
  background: rgba(53, 105, 233, 0.7);
}

/deep/ .van-tabs__nav {
  background: #f7f7f7 !important;
}

/deep/ .van-tabs__content {
  height: 100%;
}

/deep/ .van-col--4 {
  text-align: center;
}

.system {
  text-align: right;
  margin-bottom: 4px;
}

/deep/ .van-loading {
  width: 100%;
  text-align: center;
}

.count {
  width: 100%;
  font-size: 14px;
  line-height: 24px;

  span {
    margin-right: 0.8rem;
  }
}

/deep/ .van-sticky--fixed {
  padding: 0 0.3rem;
}

/deep/ .van-info {
  background: rgba(53, 105, 233, 0.7);
  right: -10px;
}

/deep/ .van-collapse {
  width: 100%;

  .van-collapse-item {
    border: 0 !important;
  }

  .van-collapse-item__content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0;
  }

  .van-cell {
    background: linear-gradient(90deg,
        rgba(53, 105, 233, 0.9) 0%,
        rgba(24, 76, 204, 1) 100%) !important;
    border: 0 !important;
    color: #ffffff;
  }
}

.rtuNo_tit_info {
  display: flex;
  justify-content: space-between;

  i {
    font-size: 20px;
    margin-right: 10px;
  }
}

.part_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #232b33;
  margin: 12px 0;
  font-weight: 500;

  .orderSort {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: normal;
    height: 28px;
    border-radius: 12px;
  }
}

.program {
  position: relative;
  width: 100%;
  // height: 200px;
  background: #ffffff;
  box-shadow: 0px 10.5523px 30.6985px rgba(57, 129, 246, 0.05);
  border-radius: 10px;
  padding: 12px 17px;
  box-sizing: border-box;

  .dot {
    position: absolute;
    top: 16px;
    left: -10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #29bc7e;
  }

  .row {
    display: flex;
    align-items: center;
  }

  .row1 {
    justify-content: space-between;

    .name {
      color: #464646;
      font-weight: 500;
    }

    .time {
      color: #6f7ea8;
      font-weight: 500;
    }

    .door {
      background: #2666de;
      border-radius: 10px;
      padding: 4px 8px;
      color: #ffffff;

      i {
        font-weight: 500;
        margin-right: 4px;
      }
    }
  }

  .row2 {
    .show_time {
      display: flex;
      width: 100%;
      font-size: 16px;
      border: 0.5px solid #888888;
      margin-top: 10px;

      .item {
        flex: 1;
        text-align: center;
        border-right: 0.5px solid #888888;

        &:last-child {
          border: none;
        }

        .label {
          color: rgba(51, 51, 51, 1);
          padding: 8px;
          font-size: 14px;
          border-bottom: 0.5px solid #888888;
        }

        .value {
          color: rgba(136, 136, 136, 1);
          padding: 9px 0;
          font-size: 14px;
        }
      }
    }
  }

  .row3 {
    position: relative;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 20px;

    /deep/ .van-progress {
      width: 100% !important;
    }

    .progress-text {
      width: 100%;
      text-align: center;
      margin-top: 10px;
    }

    .stime,
    .etime {
      position: absolute;
      top: -28px;
    }

    .stime {
      left: 0;
    }

    .etime {
      right: 0;
    }
  }

  .row4 {
    margin-top: 10px;
    justify-content: space-between;

    .right {
      color: #2ad49a;
      background: rgba(42, 212, 154, 0.13);
      padding: 1px 15px;
      border-radius: 10px;
      font-size: 13px;
    }

    .noWorking {
      color: #edb077;
      background: #fcf3eb;
    }
  }

  .row5 {
    flex-wrap: wrap;
    background: #f5f7fb;
    border-radius: 6px;
    padding: 10px;

    .r5-r1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;

      .tit {
        display: flex;
        align-items: center;
      }
    }

    .r5-r2 {
      justify-content: space-between;
      width: 100%;
      flex-wrap: wrap;
    }

    .item {
      width: 50%;
      color: #888888;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .txt {
      color: #333333;
      margin-left: 12px;
    }

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      text-align: center;
      background: #3b6be0;
      color: #ffffff;
      font-size: 12px;
    }
  }
}

.monitor_data {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    min-width: 50%;
  }

  .label {
    color: #333333;
    font-size: 12px !important;
  }

  .value {
    color: #6191f6;
  }
}

.stopping {
  color: #cf1322 !important;
  background: #fff1f0 !important;
}
</style>
